import React from 'react';
import { Button } from './ui/button';

function StepNavigation({ currentStep, onStepChange, canGoNext, canGoBack }) {
  const steps = [
    { key: 'upload', label: 'Upload', icon: 'pi-cloud-upload' },
    { key: 'select', label: 'Select', icon: 'pi-images' },
    { key: 'cart', label: 'Cart', icon: 'pi-shopping-cart' },
    { key: 'checkout', label: 'Checkout', icon: 'pi-credit-card' },
    { key: 'orders', label: 'Orders', icon: 'pi-file' }
  ];

  const currentIndex = steps.findIndex(step => step.key === currentStep);

  return (
    <div className="flex items-center justify-between mb-6">
      {/* Previous Button - Hidden on upload tab */}
      <div className="w-16">
        {currentStep !== 'upload' && (
          <Button 
            variant="outline" 
            size="sm"
            onClick={() => {
              if (currentIndex > 0) {
                onStepChange(steps[currentIndex - 1].key);
              }
            }}
            disabled={!canGoBack || currentIndex === 0}
            className="text-xs px-3 py-1 h-8"
          >
            <i className="pi pi-arrow-left mr-1"></i>
            Back
          </Button>
        )}
      </div>

      {/* Step Indicators */}
      <div className="flex items-center space-x-2 flex-1 justify-center px-4">
        {steps.map((step, index) => (
          <React.Fragment key={step.key}>
            <div 
              className={`flex items-center space-x-1 px-3 py-1 rounded-full text-xs font-medium transition-all ${
                currentStep === step.key
                  ? 'bg-blue-500 text-white'
                  : index < currentIndex
                  ? 'bg-green-100 text-green-700'
                  : 'bg-gray-100 text-gray-500'
              }`}
            >
              <i className={`pi ${step.icon} text-sm`}></i>
              <span className="hidden sm:inline">{step.label}</span>
            </div>
            {index < steps.length - 1 && (
              <div className={`h-px w-8 ${
                index < currentIndex ? 'bg-green-300' : 'bg-gray-200'
              }`} />
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Next Button - Hidden on orders tab */}
      <div className="w-16 flex justify-end">
        {currentStep !== 'orders' && (
          <Button 
            variant="outline" 
            size="sm"
            onClick={() => {
              if (currentIndex < steps.length - 1) {
                onStepChange(steps[currentIndex + 1].key);
              }
            }}
            disabled={!canGoNext || currentIndex === steps.length - 1}
            className="text-xs px-3 py-1 h-8"
          >
            Next
            <i className="pi pi-arrow-right ml-1"></i>
          </Button>
        )}
      </div>
    </div>
  );
}

export default StepNavigation;